import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';

const Post = () => {
    
    const productRef1 = useRef(null);
  const productRef2 = useRef(null);
  const productRef3 = useRef(null);
  const productRef4 = useRef(null);
  const productRef5 = useRef(null);
  const productRef6 = useRef(null);
  const productRef7 = useRef(null);

  const [scrolledIntoView1, setScrolledIntoView1] = useState(false);
  const [scrolledIntoView2, setScrolledIntoView2] = useState(false);
  const [scrolledIntoView3, setScrolledIntoView3] = useState(false);
  const [scrolledIntoView4, setScrolledIntoView4] = useState(false);
  const [scrolledIntoView5, setScrolledIntoView5] = useState(false);
  const [scrolledIntoView6, setScrolledIntoView6] = useState(false);
  const [scrolledIntoView7, setScrolledIntoView7] = useState(false);

  useEffect(() => {
    const element1 = productRef1.current; // Assign to a variable
    const element2 = productRef2.current; // Assign to a variable
    const element3 = productRef3.current; // Assign to a variable
    const element4 = productRef4.current; // Assign to a variable
    const element5 = productRef5.current; // Assign to a variable
    const element6 = productRef6.current; // Assign to a variable
    const element7 = productRef7.current; // Assign to a variable
  
    const observer1 = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setScrolledIntoView1(true);
        } else {
          setScrolledIntoView1(false);
        }
      },
      { threshold: 0.1 }
    );
  
    const observer2 = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setScrolledIntoView2(true);
        } else {
          setScrolledIntoView2(false);
        }
      },
      { threshold: 0.1 }
    );

    const observer3 = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setScrolledIntoView3(true);
        } else {
          setScrolledIntoView3(false);
        }
      },
      { threshold: 0.1 }
    );

    const observer4 = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setScrolledIntoView4(true);
        } else {
          setScrolledIntoView4(false);
        }
      },
      { threshold: 0.1 }
    );


    const observer5 = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setScrolledIntoView5(true);
        } else {
          setScrolledIntoView5(false);
        }
      },
      { threshold: 0.1 }
    );

    const observer6 = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setScrolledIntoView6(true);
        } else {
          setScrolledIntoView6(false);
        }
      },
      { threshold: 0.1 }
    );

    const observer7 = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setScrolledIntoView7(true);
        } else {
          setScrolledIntoView7(false);
        }
      },
      { threshold: 0.1 }
    );


    if (element1) {
      observer1.observe(element1);
    }
  
    if (element2) {
      observer2.observe(element2);
    }

    if (element3) {
      observer3.observe(element3);
    }
    if (element4) {
      observer4.observe(element4);
    }
    if (element5) {
      observer5.observe(element5);
    }

    if (element6) {
      observer6.observe(element6);
    }

    if (element7) {
      observer6.observe(element6);
    }


  
    return () => {
      if (element1) {
        observer1.unobserve(element1); // Use the variable here
      }
      if (element2) {
        observer2.unobserve(element2); // Use the variable here
      }

      if (element3) {
        observer3.unobserve(element3); // Use the variable here
      }
      if (element4) {
        observer4.unobserve(element4); // Use the variable here
      }

      if (element5) {
        observer5.unobserve(element5); // Use the variable here
      }

      if (element6) {
        observer6.unobserve(element6); // Use the variable here
      }

      if (element7) {
        observer7.unobserve(element7); // Use the variable here
      }

    };
  }, []);


  // Modal 

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);



  return (
    <div className='postContainer'>
        <h1 id='postHeader1'>Nos Produits </h1>

      
      
        <div id='product1'
      className={`product1 ${scrolledIntoView1 ? 'show-border' : ''}`}
      ref={productRef1}
        >

{/* headerPostApp */}
         
            <h1 id='headerPostAppGaraFashion'>
            Gara-Fashion
           </h1>
        
           
           <div className='paraContainer1'>
           <p id='paraProduct'>
           Gara-Fashion est une application innovante qui vous offre la possibilité de vendre et d'acheter tous types d'articles de mode gratuitement au Congo. Conçue pour répondre aux besoins des commerçants, cette application vous permet de créer facilement votre propre boutique en ligne et d’atteindre un large public. Grâce à ses fonctionnalités simples et pratiques, elle facilite l’écoulement de vos produits tout en augmentant votre visibilité et vos opportunités commerciales. Gara-Fashion se positionne comme un outil incontournable pour révolutionner le commerce de la mode au Congo.
           </p>
           </div>


            <div className='downloadPostContainer'>
                <div className='downloadPostContainer1'>
                <img className='iconAndroid' src="/android.png" alt="icon" />
                    <h4>
                        ANDROID :
                    </h4>

                </div>
                <div style={{ textAlign: "center", marginTop: "40px" }}>
      <h4 id="btn_download" 
      // onClick={openModal}
      >
       <a
      href="https://play.google.com/store/apps/details?id=com.leandre10.garafashioncongo2"
      style={{ textDecoration: "none", color: "inherit", fontSize: "18px" }}
      target="_blank" // Opens link in a new tab
      rel="noopener noreferrer" // Security best practice
    >
      Télécharger
    </a>
      </h4>
      <p id='fileS'></p>
    </div>
            </div>

           <div className='imageAppContainer'>
            <div className='imgC1'>
            <img className='imgApp' src="/s1.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/s2.png" alt="Description of the App" />
            </div>


            <div className='imgC1'>
            <img className='imgApp' src="/s3.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/s4.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/s5.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/s6.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/s7.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/s8.png" alt="Description of the App" />
            </div>


           </div>

           <div >
                
        <Link 
            to="/privacy" 
           
            id="btn_download"
            >
             Politique de confidentialité
            </Link>
  
                </div>
        </div>


{/* GARA-AUTO */}

{/*   Gara-Auto on stand by until Google play STore Confirmed */}

<div 
 id="product2"
 className={`product2 ${scrolledIntoView5 ? 'show-border' : ''}`}
 ref={productRef5}
        >

         
           <h1 id='headerPostAppGaraAuto'>
            Gara-Auto
           </h1>


           <div className='paraContainer1'>
           <p id='paraProduct'>
           Gara-Auto est une application innovante qui vous permet de vendre et d'acheter des véhicules d'occasion au Congo en toute simplicité et sécurité. Elle vous offre l'opportunité de créer facilement votre propre entreprise automobile en ligne, de gérer vos annonces efficacement et d’atteindre une large clientèle intéressée par vos offres. Grâce à ses fonctionnalités intuitives et son interface conviviale, Gara-Auto révolutionne le marché de l’automobile en facilitant les transactions et en augmentant votre visibilité.
           </p>
           </div>


            <div className='downloadPostContainer'>
                <div className='downloadPostContainer1'>
                <img className='iconAndroid' src="/android.png" alt="icon" />
                    <h4>
                        ANDROID :
                    </h4>

                </div>
                <div style={{ textAlign: "center", marginTop: "40px" }}>
      <h4 id="btn_download" 
     
      >
        <a
      href="https://play.google.com/store/apps/details?id=com.leandre10.garaautocongo2"
      style={{ textDecoration: "none", color: "inherit", fontSize: "18px" }}
      target="_blank"
      rel="noopener noreferrer"
    >
          Télécharger
        </a>
      </h4>
      <p id='fileS'></p>
    </div>
            </div>

<div className='imageAppContainer'>
            <div className='imgC1'>
            <img className='imgApp' src="/a1.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/a2.png" alt="Description of the App" />
            </div>


            <div className='imgC1'>
            <img className='imgApp' src="/a3.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/a4.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/a5.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/a6.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/a7.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/a8.png" alt="Description of the App" />
            </div>


           </div>


           <div >
                
        <Link 
            to="/privacy2" 
           
            id="btn_download"
            >
             Politique de confidentialité
            </Link>
  
                </div>
        </div> 



        {/* Gara-Immo */}
<div 
 id="product3"
 className={`product3 ${scrolledIntoView7 ? 'show-border' : ''}`}
 ref={productRef5}
        >

         
           <h1 id='headerPostAppGaraImmo'>
            Gara-Immo
           </h1>


           <div className='paraContainer1'>
          <p id="paraProduct">
  Gara-Immo est une application innovante qui vous permet de vendre, louer et acheter des biens immobiliers au Congo en toute simplicité et en toute sécurité. Elle vous offre l’opportunité de créer facilement votre propre agence immobilière en ligne, de gérer vos annonces avec efficacité, et d’atteindre une large clientèle intéressée par vos offres. Grâce à ses fonctionnalités intuitives et son interface conviviale, Gara-Immo révolutionne le marché de l’immobilier en facilitant les transactions et en renforçant votre visibilité.
</p>

           </div>


            <div className='downloadPostContainer'>
                <div className='downloadPostContainer1'>
                <img className='iconAndroid' src="/android.png" alt="icon" />
                    <h4>
                        ANDROID :
                    </h4>

                </div>
                <div style={{ textAlign: "center", marginTop: "40px" }}>
      <h4 id="btn_download" 
     
      >
        <a
      href="https://play.google.com/store/apps/details?id=com.leandre10.garaimmo"
      style={{ textDecoration: "none", color: "inherit", fontSize: "18px" }}
      target="_blank"
      rel="noopener noreferrer"
    >
          Télécharger
        </a>
      </h4>
      <p id='fileS'></p>
    </div>
            </div>

<div className='imageAppContainer'>
            <div className='imgC1'>
            <img className='imgApp' src="/I1.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/I2.png" alt="Description of the App" />
            </div>


            <div className='imgC1'>
            <img className='imgApp' src="/I3.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/I5.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/I7.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/I8.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/I9.png" alt="Description of the App" />
            </div>

            <div className='imgC1'>
            <img className='imgApp' src="/I10.png" alt="Description of the App" />
            </div>


           </div>


           <div >
                
        <Link 
            to="/privacy3" 
           
            id="btn_download"
            >
             Politique de confidentialité
            </Link>
  
                </div>
        </div> 





        {/* second  */}

        <div
        id="product2"
        className={`product2 ${scrolledIntoView2 ? 'show-border' : ''}`}
        ref={productRef2}
      >
        <h1 id='headerProduct2'> À propos</h1>

        <div className='paraContainer2'>
        <p id='paraProduct2'>
        Gara-Innov est une startup innovante, visionnaire et dynamique, dédiée à la conception, au développement et à la modernisation des applications mobiles Android et iOS. En intégrant les dernières technologies de pointe, nos solutions personnalisées répondent aux exigences du marché tout en se concentrant sur les besoins spécifiques des utilisateurs. Notre engagement inébranlable envers l'innovation vise à promouvoir un écosystème numérique en plein essor dans le secteur africain.

        Nous voyons les défis locaux non pas comme des obstacles, mais comme des opportunités uniques de faire évoluer les pratiques traditionnelles grâce à des solutions numériques efficaces et accessibles. En offrant des produits créatifs, performants et à fort impact, nous contribuons activement à la croissance économique, sociale et technologique du continent africain, tout en renforçant la compétitivité des entreprises locales sur la scène internationale.

        Grâce à notre passion pour l'excellence, notre expertise technologique et notre approche centrée sur l’utilisateur, Gara-Innov aspire à devenir un catalyseur incontournable de la transformation numérique en Afrique. Notre vision est de bâtir un avenir connecté où chaque individu et chaque entreprise peut prospérer grâce aux opportunités offertes par l’innovation technologique.
        </p>
        </div>
      </div>


      {/* third */}
         <div
        id="product3"
        className={`product3 ${scrolledIntoView3 ? 'show-border' : ''}`}
        ref={productRef3}
      >
        <h1 id='headerProduct2'>L'Équipe</h1>

        <div className='paraContainer2'> 
        <p id='paraProduct2'>
        Notre équipe est composée d'ingénieurs talentueux et passionnés, experts dans leurs domaines respectifs. Animés par une volonté constante d'excellence et d'innovation, nous possédons une solide expérience dans le développement, la conception et la mise en œuvre de solutions technologiques adaptées aux besoins spécifiques de chaque client. Nous mettons à profit notre créativité, notre expertise technique et notre capacité à résoudre des problèmes complexes pour développer des produits et services révolutionnaires.

        Notre esprit collaboratif, notre capacité d’adaptation et notre engagement envers l'amélioration continue garantissent des solutions à la hauteur des exigences du marché en constante évolution. Ensemble, nous formons une équipe soudée et dynamique, prête à relever les défis les plus ambitieux et à repousser les limites de la technologie. Grâce à notre passion pour notre métier et notre volonté de servir au mieux nos utilisateurs, notre équipe s'efforce de transformer chaque vision en réalité et de marquer durablement le secteur technologique par nos contributions.
        </p>

        </div>
      </div>



      {/* fourth */}
         <div
        id="product3"
        className={`product3 ${scrolledIntoView6 ? 'show-border' : ''}`}
        ref={productRef6}
      >
        <h1 id='headerProduct3'>Un mot de notre PDG et Fondateur</h1>

        <div className='paraContainer4' >

          <div className='paraContainer5'>
            
             <div className='imgC2'>
            <img className='imgApp2' src="/pic.jpg" alt="Description of the App" />
            </div>

            <p>Isaac Peniel Leandre Mbemba</p>
          </div>


           <div className='paraContainer5'> 
        <p id='paraProduct2'>"
       Gara-Innov transforme les défis africains en opportunités digitales, propulsant l’innovation et la compétitivité à l’échelle mondiale."
        </p>

        </div>

        </div>

       
      </div>


    {/* Footer */}
    <div
        id="product4"
        className={`product4 ${scrolledIntoView4 ? 'show-border' : ''}`}
        ref={productRef4}
      >
       
        <p id='paraProduct2'>
            ©Gara-Innov 2025
        </p>
      </div>
      
    </div>
  )
}

export default Post
